import { getEntireList } from '@/services/modules/entire'
import { CHANGE_CURR_PAGE, CHANGE_ENTIRE_LIST, CHANGE_IS_LOADING, CHANGE_TOTAL_COUNT } from './constants'

export function changeCurrPageAction(currPage) {
  return {
    type: CHANGE_CURR_PAGE,
    currPage: currPage
  }
}

export function changeEntireListAction(entireList) {
  return {
    type: CHANGE_ENTIRE_LIST,
    entireList: entireList
  }
}

export function changeTotalCountAction(totalCount) {
  return {
    type: CHANGE_TOTAL_COUNT,
    totalCount: totalCount
  }
}

export function changeIsLoadingAction(isLoading) {
  return {
    type: CHANGE_IS_LOADING,
    isLoading: isLoading
  }
}

// 异步请求
export function fetchEntireListAction(offset) {
  return async (dispatch) => {
    // 修改isLoading状态
    dispatch(changeIsLoadingAction(true))
    const res = await getEntireList(offset)
    dispatch(changeIsLoadingAction(false))

    dispatch(changeEntireListAction(res.list))
    dispatch(changeTotalCountAction(res.totalCount))
  }
}
